import { BaseExportModal, ExportModalProps } from './ExportModal'
import { CAMPAIGNS_COLUMNS } from 'features/campaigns/campaignsColumns'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useDownload } from 'features/download-widget'
import { exportCampaignsV2, getDownloadStatus } from 'services/downloads'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function CampaignExportModal(props: ExportModalProps) {
  const campaignColumnHelper = createExportColumnHelper({
    columns: CAMPAIGNS_COLUMNS,
  })
  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Campaign Attributes',
      elements: [
        campaignColumnHelper.retrieveColumn('name'),
        campaignColumnHelper.retrieveColumn('description'),
        campaignColumnHelper.retrieveColumn('company_type'),
        campaignColumnHelper.retrieveColumn('product'),
        campaignColumnHelper.retrieveColumn('created'),
        campaignColumnHelper.retrieveColumn('modified'),
        campaignColumnHelper.retrieveColumn('days_since_last_update'),
        campaignColumnHelper.retrieveColumn('contact_company_count'),
        campaignColumnHelper.retrieveColumn('door_count'),
      ],
    },
    {
      title: 'Deals',
      elements: [
        campaignColumnHelper.retrieveColumn('deal_count'),
        campaignColumnHelper.retrieveColumn('deal_count_won'),
        campaignColumnHelper.retrieveColumn('deal_perc'),
        campaignColumnHelper.retrieveColumn('deal_perc_won'),
      ],
    },
    {
      title: 'Contacts',
      elements: [
        campaignColumnHelper.retrieveColumn('contact_count'),
        campaignColumnHelper.retrieveColumn('companies_with_contacts'),
        campaignColumnHelper.retrieveColumn('companies_with_contacts_perc'),
      ],
    },
    {
      title: 'Forecasts',
      elements: [
        campaignColumnHelper.retrieveColumn('taro'),
        campaignColumnHelper.retrieveColumn('taro_closed'),
        campaignColumnHelper.retrieveColumn('est_meals_day'),
      ],
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Campaigns...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await exportCampaignsV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'campaigns',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Campaigns Download"
      subTitle="Download up to 10,000 campaigns at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Campaigns"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
